module.exports = __webpack_public_path__ + "media/backgrounds/john-towner-JgOeRuGD_Y4-unsplash-ff9a52f0.jpg";